/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import LoginForm from './LoginForm';
  
import * as validations from '../../validations/validations';

import { Segment} from 'semantic-ui-react'; 
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment'; 
import $ from 'jquery';
 

class ManageLoginForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            strings:[],
            permisos:{},
			tag:{
                    }
		};
		
	}
    
    
    componentDidMount(){
        

        
		
    }
    

    handleChange=(event, data)=> {

        let tag = this.state.tag;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		tag[field[0]]= value;
		else{
             if(!tag[field[0]]){
                    tag[field[0]]={}
                }
			tag[field[0]][field[1]]= value;
		}
        
		
        this.setState({"tag": tag});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let tag=this.state.tag;
              
        if(!validations.requerido(tag.tag)){
            errors.tag=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        this.props.tagActions.save(this.state.tag).then(() => {
            toastr.success("Registro guardado!!!.");
            //this.props.history.push('/tags');
        });
        
    }

       
    render() {	
          
       return (
              <Segment  style={{minHeight: "93vh"}}>
                <LoginForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.tag}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
              
                    
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    let id = ownProps.match.params.id;
   
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        id
    }

}

function mapDispatchToProps(dispatch){

	return {   
        
	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageLoginForm);